// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_ba-4";
export var collapsed = "_ba-1";
export var headerBar = "_ba-0";
export var leftHeaderContent = "_ba-3";
export var subjectContainer = "_ba-2";